import { render, staticRenderFns } from "./nationManager.vue?vue&type=template&id=6ef9644e"
import script from "./nationManager.vue?vue&type=script&lang=js"
export * from "./nationManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ef9644e')) {
      api.createRecord('6ef9644e', component.options)
    } else {
      api.reload('6ef9644e', component.options)
    }
    module.hot.accept("./nationManager.vue?vue&type=template&id=6ef9644e", function () {
      api.rerender('6ef9644e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/mail/nationManager.vue"
export default component.exports